import React from 'react'
import { Helmet } from 'react-helmet'

const OneSignal = ({ ...props }) => (
  <Helmet {...props}>
    <script src="https://cdn.onesignal.com/sdks/OneSignalSDK.js" async=""></script>
    <script>
      {`
// appId: "4dd7c402-c5b6-489e-941e-fe0cc6fd3368",
if (!/Android|webOS|iPhone|iPad|iPod|Opera Mini/i.test(navigator.userAgent)) {
	const OneSignal = window.OneSignal || []
	  OneSignal.push(['init', {
		appId: 'caaf25b3-edc7-47e2-9418-011d017f1dd8',
		safari_web_id: 'web.onesignal.auto.2473987d-7114-4e84-8494-f768208d432f',
		autoRegister: true,
		notifyButton: {
			enable: true, /* Set to false to hide */
			text: {
				'tip.state.unsubscribed': 'Nichts mehr verpassen',
				'tip.state.subscribed': 'Sie bekommen die Benachrichtigung',
				'tip.state.blocked': 'Sie haben die Benachritigungen blockiert',
				'message.prenotify': 'Klicken um die Benachrichtiungen zu aktivieren',
				'message.action.subscribed': 'Danke fürs aktivieren der Benachrichtigungen',
				'message.action.resubscribed': 'Sie haben die Benachrichtigungen aktiviert',
				'message.action.unsubscribed': 'Sie werden keine Benachrichtigungen mehr bekommen',
				'dialog.main.button.subscribe': 'Aktivieren',
				'dialog.main.button.unsubscribe': 'Deaktivieren',
			},
		},
		welcomeNotification: {
			'title': 'Stol.it: Nachrichten für Südtirol',
			'message': 'Danke für die Aktivierung der Benachrichtigungen',
		},
	}])

	  function subscribe(event) {
		OneSignal.push(['registerForPushNotifications'])
	  event.preventDefault()
	}

	OneSignal.push(function () {
		// If we're on an unsupported browser, do nothing

		if (!OneSignal.isPushNotificationsSupported()) {
			console.log('not supported')
	  return
		}

		OneSignal.push(['getNotificationPermission', function (permission) {
			console.log('getNotificationPermission')
	  if (permission !== 'denied') {
				OneSignal.isPushNotificationsEnabled(function (isEnabled) {
					if (!isEnabled) {
						console.log('test')
					}
				})
			}
		}])
	})
}
    `}
    </script>
  </Helmet>
)

OneSignal.propTypes = {}

OneSignal.defaultProps = {}

export default OneSignal
